import { GET_DRIVERS_MAP, GET_LEVELPATH_API, GET_SERVICES } from "../utils/api";

export const LOAD_CITIES = "@MAP/LOAD_CITIES";
export const LOAD_SERVICES = "@MAP/LOAD_SERVICES";
export const LOAD_DRIVERS_MAP = "@MAP/LOAD_DRIVERS_MAP";
export const DRIVERS_MAP_LOADING = "@MAP/DRIVERS_MAP_LOADING";

export interface ILOAD_CITIES {
  type: typeof LOAD_CITIES;
  payload: {
    levels: null;
  };
}
export async function loadCities(body: any): Promise<ILOAD_CITIES> {
  try {
    const response = await GET_LEVELPATH_API(body);
    return {
      type: LOAD_CITIES,
      payload: {
        levels: response.data,
      },
    };
  } catch (error) {
    return {
      type: LOAD_CITIES,
      payload: {
        levels: Object(error),
      },
    };
  }
}

export interface ILOAD_SERVICES {
  type: typeof LOAD_SERVICES;
  payload: {
    services: null;
  };
}

export async function loadServices(): Promise<ILOAD_SERVICES> {
  try {
    const response = await GET_SERVICES();
    return {
      type: LOAD_SERVICES,
      payload: {
        services: response.data,
      },
    };
  } catch (error) {
    return {
      type: LOAD_SERVICES,
      payload: {
        services: Object(error),
      },
    };
  }
}

export interface ILOAD_DRIVERS_MAP {
  type: typeof LOAD_DRIVERS_MAP;
  payload: {
    drivers: null | [];
  };
}

export async function loadDriversMap(body): Promise<ILOAD_DRIVERS_MAP> {
  try {
    const response = await GET_DRIVERS_MAP(body);

    return {
      type: LOAD_DRIVERS_MAP,
      payload: {
        drivers: response?.data?.data?.drivers,
      },
    };
  } catch (error) {
    return {
      type: LOAD_DRIVERS_MAP,
      payload: {
        drivers: [],
      },
    };
  }
}
